<template>
    <div class="big-screen-container">
            <!-- 顶部标题 -->
    <div  class="wheel-replacer-container">
        <section>
            <div style="margin: 0;padding: 0;width: 100%;">
               <p>
                   <img style="width:100%" :src="isOriginalImage?(carImageUrl||originalImage):resultImage"/>

               </p>

            </div>
            <footer class="ft_box">
                <div class="ft_item" style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;">
                    <div style="padding: 10px 40px;display:flex;flex-direction: row;align-items: center;color: #707070;">
                         <span  @click="openCar=true"  style="padding-right: 20px;display: flex;flex-direction: column;text-align: center;">
                            <img style="width:50px;height: 50px;" src="../../assets/images/car_icon.png"/>
                             <label>汽车选择</label>
                       </span>
                        <span @click="goContrast" v-if="resultImage" style="padding-right: 20px;flex-direction: column;display: flex;text-align: center;">
                            <img style="width:50px;height: 50px;" src="../../assets/images/contrast_icon.png"/>
                             <label>改装对比</label>
                       </span>
                       <span @click="drawerHub=true" style="display: flex;flex-direction: column; text-align: center;">
                            <img style="width:50px;height: 50px;" src="../../assets/images/hub_icon.png"/>
                            <label>轮毂选择</label>
                       </span>
                    </div>
                </div>
            </footer>
        </section>
        <el-container style="display: none">
            <el-main class="app-main">
                <!-- 上传区域 -->
                <!-- 结果展示 -->
                <el-row :gutter="20" v-if="carUseUrl||originalImage || resultImage">
                    <el-col :span="12" v-if="originalImage">
                            <img :src="originalImage" alt="原始图片" class="result-image" />
                    </el-col>

                    <el-col :span="12" v-if="resultImage">
                        <el-image
                                class="result-image"
                                :preview-src-list="srcList"
                                :src="resultImage"
                                fit="fill"></el-image>


                    </el-col>
                </el-row>

                <!-- 控制区域 -->


                <section style="display:flex;justify-content:space-between;flex-direction:column">
                    <!--left start-->

                        <div class="upload-card" style="background: #f5f5f5">
                            <div slot="header" class="card-header">
                                <span><span class="status-indicator" :class="{'status-ready': hasCarImage, 'status-waiting': !hasCarImage}"></span>汽车图片</span>

                            </div>

                            <div v-if="!carUseUrl">


                                <!--                                    <div v-if="carImageFile" class="file-info">-->
                                <!--                                        <el-tag type="success">已选择: {{ carImageFile.name }}</el-tag>-->
                                <!--                                        <el-button size="mini" icon="el-icon-view" @click="carImagePreview = carImageFile.url">预览</el-button>-->
                                <!--                                    </div>-->
                            </div>

                            <div v-else>
                                <el-input
                                        v-model="carImageUrl"
                                        placeholder="请输入汽车图片URL"
                                        class="url-input"
                                >
                                    <template slot="prepend">URL</template>
                                    <el-button slot="append" icon="el-icon-link" @click="loadCarImageFromUrl"></el-button>
                                </el-input>
                            </div>

                            <!--                                <div v-if="carImagePreview" class="image-preview">-->
                            <!--                                    <img :src="carImagePreview" alt="汽车图片预览" class="preview-image" />-->
                            <!--                                    <div>-->
                            <!--                                        <el-button size="mini" @click="carImagePreview = null">关闭预览</el-button>-->
                            <!--                                    </div>-->
                            <!--                                </div>-->

                            <el-input
                                    v-model="wheelImageUrl"
                                    placeholder="请输入轮毂图片URL"
                                    class="url-input"
                            >
                                <template slot="prepend">轮毂地址</template>
                                <el-button slot="append" icon="el-icon-link" @click="loadWheelImageFromUrl"></el-button>
                            </el-input>
                            <!--                                <div slot="header" class="card-header">-->
                            <!--                                    <span><span class="status-indicator" :class="{'status-ready': hasWheelImage, 'status-waiting': !hasWheelImage && wheelImageUrl === '', 'status-error': hasWheelImage === false}"></span>轮毂图片 (可选)</span>-->
                            <!--                                    <el-switch-->
                            <!--                                            v-model="wheelUseUrl"-->
                            <!--                                            active-text="使用URL"-->
                            <!--                                            inactive-text="上传文件"-->
                            <!--                                            @change="handleWheelInputTypeChange"-->
                            <!--                                    />-->
                            <!--                                </div>-->

                            <!--                                <div v-if="!wheelUseUrl">-->
                            <!--                                    <el-upload-->
                            <!--                                            class="upload-demo"-->
                            <!--                                            :auto-upload="false"-->
                            <!--                                            :on-change="handleWheelFileChange"-->
                            <!--                                            :show-file-list="false"-->
                            <!--                                            action="#"-->
                            <!--                                    >-->
                            <!--                                        <el-button size="medium" type="warning" icon="el-icon-upload">-->
                            <!--                                            选择轮毂图片-->
                            <!--                                        </el-button>-->
                            <!--                                        <div slot="tip" class="el-upload__tip">-->
                            <!--                                            不选择将使用默认轮毂-->
                            <!--                                        </div>-->
                            <!--                                    </el-upload>-->

                            <!--                                    <div v-if="wheelImageFile" class="file-info">-->
                            <!--                                        <el-tag type="warning">已选择: {{ wheelImageFile.name }}</el-tag>-->
                            <!--                                        <el-button size="mini" icon="el-icon-view" @click="wheelImagePreview = wheelImageFile.url">预览</el-button>-->
                            <!--                                    </div>-->
                            <!--                                </div>-->

                            <!--                                <div v-else>-->
                            <!--                                    <el-input-->
                            <!--                                            v-model="wheelImageUrl"-->
                            <!--                                            placeholder="请输入轮毂图片URL"-->
                            <!--                                            class="url-input"-->
                            <!--                                    >-->
                            <!--                                        <template slot="prepend">URL</template>-->
                            <!--                                        <el-button slot="append" icon="el-icon-link" @click="loadWheelImageFromUrl"></el-button>-->
                            <!--                                    </el-input>-->
                            <!--                                </div>-->

                            <!--                                <div v-if="wheelImagePreview" class="image-preview">-->
                            <!--                                    <img :src="wheelImagePreview" alt="轮毂图片预览" class="preview-image" />-->
                            <!--                                    <div>-->
                            <!--                                        <el-button size="mini" @click="wheelImagePreview = null">关闭预览</el-button>-->
                            <!--                                    </div>-->
                            <!--                                </div>-->

                            <!--                                <el-button-->
                            <!--                                        type="primary"-->
                            <!--                                        icon="el-icon-search"-->
                            <!--                                        :loading="processing"-->
                            <!--                                        :disabled="!hasCarImage"-->
                            <!--                                        @click="detectWheels"-->
                            <!--                                        size="medium"-->
                            <!--                                >-->
                            <!--                                    {{ processing ? '检测中...' : '检测轮毂' }}-->
                            <!--                                </el-button>-->

                            <div style="display: flex;text-align: center;flex-direction: row;justify-content: center;padding-bottom: 12px">


                            <!--                                <el-button-->
                            <!--                                        type="info"-->
                            <!--                                        icon="el-icon-download"-->
                            <!--                                        :disabled="!resultImage"-->
                            <!--                                        @click="downloadResult"-->
                            <!--                                        size="medium"-->
                            <!--                                >-->
                            <!--                                    下载结果-->
                            <!--                                </el-button>-->

                            <el-button
                                    type="danger"
                                    icon="el-icon-delete"
                                    @click="clearAll"
                                    size="medium"
                            >
                                清除所有
                            </el-button>
                            </div>
                        </div>

                    <!--right end-->
                </section>

                <!-- 结果信息 -->
                <el-card v-if="detectionResult" class="info-card" style="display: none">
                    <div slot="header" class="card-header">
                        <span>处理信息</span>
                    </div>

                    <el-descriptions :column="2" border>
                        <el-descriptions-item label="检测轮毂数量">
                            <el-tag type="success">{{ detectionResult.detection_count || 0 }} 个</el-tag>
                        </el-descriptions-item>

                        <el-descriptions-item label="处理时间">
                            <el-tag>{{ processingTime }}ms</el-tag>
                        </el-descriptions-item>

                        <el-descriptions-item label="轮毂类型">
                            <el-tag :type="detectionResult.custom_wheel_used ? 'warning' : 'info'">
                                {{ detectionResult.custom_wheel_used ? '自定义轮毂' : '默认轮毂' }}
                            </el-tag>
                        </el-descriptions-item>

                        <el-descriptions-item label="来源方式" v-if="detectionResult.wheel_source">
                            <el-tag>{{ detectionResult.wheel_source === 'file' ? '文件上传' : 'URL输入' }}</el-tag>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-card>
            </el-main>
        </el-container>

        <!-- 加载遮罩 -->
        <el-dialog
                :visible.sync="processing"
                :show-close="false"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                width="30%"
        >
            <div class="loading-dialog">
                <el-progress
                        type="circle"
                        :percentage="progress"
                        :status="progress === 100 ? 'success' : undefined"
                />
                <div class="loading-text">
                    <p>{{ loadingText }}</p>
                    <p v-if="progress > 0">{{ progress }}%</p>
                </div>
            </div>
        </el-dialog>

        <el-dialog
                :visible.sync="openCar"
                :show-close="false"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                width="50%">
                <div>
                    <div>
                        <el-switch
                                v-model="carUseUrl"
                                active-text="使用URL"
                                inactive-text="上传文件"
                                @change="handleCarInputTypeChange"
                        />
                    </div>
                    <div v-if="carUseUrl">
                    <p style="font-weight: bold;font-size: 16px;"><label>汽车选择</label></p>
                    <p style="display: flex;flex-direction: row;align-items: center;">
                        <label style="display:inline-block;white-space: nowrap;">车型：</label>
                        <el-cascader v-model="style_ids"
                                     style="width: 100%" ref="cascaderCarStyle" @change="getval($event)"
                                     :props="{ value: 'id',label: 'name',children: 'children',checkStrictly: true}" :options="carStyleMenus" clearable></el-cascader>
                    </p>
                    <p style="display: flex;flex-direction: row;align-items: center;">
                        <label style="display:inline-block;white-space: nowrap;">年份：</label>
                        <el-select
                                v-model="year_id"
                                filterable
                                clearable
                                default-first-option
                                placeholder="请选择年份">
                            <el-option
                                    v-for="item in carYearList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <span style="margin-left: 10px;">
                          <el-button @click="searchCar" type="primary">确定</el-button>
                        </span>
                    </p>
                    <div>
                       <div>
                           <span @click="chooseCar(item,index)" style="margin:0 10px 10px 0; " v-for="(item,index) in carList" :key="index">
                               <img style="width:100px;height: 100px;border-radius: 5px;" :src="item.file_url"/>
                           </span>
                       </div>
                    </div>
                    </div>
                    <div v-if="!carUseUrl">
                        <p style="font-weight: bold;font-size: 16px;"><label>请选择上传汽车图片</label></p>
                        <el-upload
                                class="upload-demo"
                                :auto-upload="false"
                                :on-change="handleCarFileChange"
                                :show-file-list="false"
                                action="#"
                        >
                            <el-button size="medium" type="primary" icon="el-icon-upload">
                                选择汽车图片
                            </el-button>
                            <div slot="tip" class="el-upload__tip">
                                支持jpg、png、jpeg格式，大小不超过10MB
                            </div>
                        </el-upload>
                    </div>
                </div>
        </el-dialog>

        <el-drawer
                title="轮毂选择"
                :visible.sync="drawerHub"
                :show-close="true"
                :modal="false"
                :with-header="false">
               <section>

                   <div style="margin: 20px;display: flex;flex-direction:row;flex-wrap: wrap;">
                       <span :class="hubIndex==index?'active':''" @click="radioChangeHub(item,index)" v-for="(item,index) in hubList" :key="index" style="padding: 10px;">
                         <img style="width:100px;height:100px;" :src="item.goods_img"/>
                       </span>
                   </div>
                   <div style="text-align: center;">
                       <el-button
                               type="success"
                               icon="el-icon-refresh"
                               :loading="processing"
                               :disabled="!hasCarImage"
                               @click="replaceWheels"
                               size="medium"
                       >
                           {{ processing ? '替换中...' : '替换轮毂' }}
                       </el-button>
                   </div>
               </section>
<!--            <el-table-->
<!--                    style="margin-top: 20px;"-->
<!--                    ref="multipleTable"-->
<!--                    :data="hubList"-->
<!--                    size="mini"-->
<!--                    stripe-->
<!--                    border-->
<!--            >-->
<!--                <el-table-column label="" width="50" align="center">-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-radio v-model="curHub" :label="scope.row" @input="clickChange(scope.row,scope.$index)">{{ "" }}</el-radio>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column  type="index" label="序号" width="50"></el-table-column>-->
<!--                <el-table-column-->
<!--                        label="名称"-->
<!--                        width="150"-->
<!--                        :show-overflow-tooltip='true'-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--            <span>-->
<!--               {{scope.row.goods_name}}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        label="孔距"-->
<!--                        width="80"-->
<!--                        :show-overflow-tooltip='true'-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--            <span>-->
<!--               {{scope.row.pitch?scope.row.pitch.name:''}}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column-->
<!--                        label="市场价"-->
<!--                        width="80"-->
<!--                        :show-overflow-tooltip='true'-->
<!--                >-->
<!--                    <template slot-scope="scope">-->
<!--            <span>-->
<!--               {{scope.row.market_price}}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--            </el-table>-->
        </el-drawer>
        <el-drawer
                title="汽车选择"
                :visible.sync="drawerCar"
                :with-header="false">
            <el-table
                    style="margin-top: 20px;"
                    ref="multipleTable"
                    :data="carList"
                    size="mini"
                    stripe
                    border
            >
                <el-table-column label="" width="50" align="center">
                    <template slot-scope="scope">
                        <el-radio v-model="curCar" :label="scope.row" @input="clickChange1(scope.row,scope.$index)">{{ "" }}</el-radio>
                    </template>
                </el-table-column>
                <el-table-column  type="index" label="序号" width="50"></el-table-column>
                <el-table-column
                        label="名称"
                        width="150"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
            <span>
               {{scope.row.title}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="车系"
                        width="80"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
                <span>
                    {{scope.row.style&&scope.row.style.parent?scope.row.style.parent.name:''}}
                   {{scope.row.style?scope.row.style.name:''}}
                </span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="孔距"
                        width="80"
                        :show-overflow-tooltip='true'
                >
                    <template slot-scope="scope">
            <span>
               {{scope.row.pitch?scope.row.pitch.name:''}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-drawer>
    </div>
 </div>
</template>

<script>
    import axios from 'axios'
    // API配置
    const API_BASE_URL = 'https://jm.shuangma88.com'; // 根据实际情况修改

    // 创建axios实例
    const http = axios.create({
        baseURL: API_BASE_URL,
        timeout: 30000,
        headers: {
            'Content-Type': 'application/json'
        }
    });

    // 请求拦截器
    http.interceptors.request.use(
        (config) => {
            // 可以在这里添加token等认证信息
            // const token = localStorage.getItem('token');
            // if (token) {
            //   config.headers.Authorization = `Bearer ${token}`;
            // }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // 响应拦截器
    http.interceptors.response.use(
        (response) => {
            return response.data;
        },
        (error) => {
            const errorMsg = error.response?.data?.error || error.message || '网络请求失败';
           // ElementUI.Message.error(errorMsg);
            console.log(errorMsg)
            return Promise.reject(error);
        }
    );

    // // 图片工具函数
    // const imageUtils = {
    //     fileToBase64(file) {
    //         return new Promise((resolve, reject) => {
    //             const reader = new FileReader();
    //             reader.onload = (e) => resolve(e.target.result);
    //             reader.onerror = (error) => reject(error);
    //             reader.readAsDataURL(file);
    //         });
    //     },
    //
    //     base64ToPath(base64) {
    //         return base64;
    //     }
    // };

    export default {
        name: "refitHub",
        data() {
            return {
                hubIndex:'',
                style_ids:[],
                style_id:'',
                year_id:'',
                cateMenus:[],
                carStyleMenus:[],
                carYearList:[],
                isOriginalImage:true,
                curHub:'',
                hubList:[],
                drawerHub:false,
                curCar:'',
                carList:[],
                drawerCar:false,
                total:0,
                total1:0,
                srcList:[],
                // API实例
                api: http,

                // 汽车图片相关
                carUseUrl: false,
                carImageFile: null,
                carImageUrl: 'https://jmhub.oss-cn-beijing.aliyuncs.com/user-dir/jm/202510121120535496.jpeg',
                carImagePreview: null,

                // 轮毂图片相关
                wheelUseUrl: true,
                wheelImageFile: null,
                wheelImageUrl: 'https://luqb.oss-cn-beijing.aliyuncs.com/user-dir/icbc/20259261553362637.png',
                wheelImagePreview: null,

                openCar:false,
                // 处理相关
                confidence: 0.4,
                processing: false,
                progress: 0,
                loadingText: '处理中，请稍候...',


                // 结果相关
                originalImage: null,
                resultImage: null,
                detectionResult: null,
                processingTime: null,

                // 上传状态
                uploadedFiles: {
                    car: null,
                    wheel: null
                }
            };
        },
        computed: {

            hasCarImage() {
                return (this.carImageFile && !this.carUseUrl) ||
                    (this.carImageUrl && this.carUseUrl) ||
                    (this.uploadedFiles.car && this.uploadedFiles.car.file_path);
            },
            hasWheelImage() {
                return (this.wheelImageFile && !this.wheelUseUrl) ||
                    (this.wheelImageUrl && this.wheelUseUrl) ||
                    (this.uploadedFiles.wheel && this.uploadedFiles.wheel.file_path);
            }
        },
        created() {
            this.getHubList();
            this.getCarStyleMenus();
            this.getCarYeaList();
        },
        methods: {
            searchCar(){

               this.getCarList();
            },
            chooseCar(item,index){
                this.isOriginalImage=true;
                this.carImageUrl=item.file_url;
                this.openCar=false;
                console.log(index)
            },
            getCarStyleMenus(){
                let _this = this;
                let params={
                    access_token:sessionStorage.getItem('token'),
                    company_id:sessionStorage.getItem('company_id'),
                };
                this.$axios.findCarStyleTree(params).then((res)=>{
                    if(res.code == 200) {
                        _this.carStyleMenus=res.data;
                    }
                });
                _this.submit=false;
            },
            getCarList(){
                let _this=this;
                const param1 = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token')
                }
                if(!this.style_id){
                    this.$message.error('请选择车型');
                    return;
                }

                param1.style_id=this.style_id;
                if(this.year_id){
                    param1.year_id=this.year_id;
                }
                this.carList=[];
                _this.total1=0;
                this.$axios.findCarListP(param1).then(res=>{
                    if(res.code == 200){
                        //  console.log(res,1111);
                        _this.carList = res.data.data
                        _this.total1 = res.data.total
                    }
                })
            },
            getCarYeaList(){
                let _this = this;
                let params={
                    access_token:sessionStorage.getItem('token'),
                    company_id:sessionStorage.getItem('company_id'),
                };
                this.$axios. findCarYearList(params).then((res)=>{
                    if(res.code == 200) {
                        _this.carYearList=res.data;
                    }
                });
                _this.submit=false;
            },

            getval() {
                let _this = this;
                const obj = this.$refs['cascaderCarStyle'].getCheckedNodes();
                _this.style_id = obj[0].data.id;
            },
            goContrast(){
                if(this.resultImage){
                    this.isOriginalImage=!this.isOriginalImage;
                }
            },
            radioChangeHub(item,index){
                console.log('44444-----',item)
                this.hubIndex=index;
                console.log('5555-----',  this.hubIndex)
                this.carUseUrl=true;
                this.wheelImageUrl=item.goods_img;
                console.log(index);
            },
            clickChange(row,index){
                this.index=index;
                this.id=row.id;
                this.wheelImageUrl=row.goods_img;
                this.drawerHub=false;
            },
            clickChange1(row){

                this.carImageUrl=row.file_url;
                this.originalImage=row.file_url;
                this.drawerCar=false;
            },
            getHubList(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token')
                }
                this.$axios.findHubListP(param).then(res=>{
                    if(res.code == 200){
                        //  console.log(res,1111);
                        this.hubList = res.data.data
                        this.total = res.data.total
                    }
                }).catch(error=>{
                    console.log(error);
                })



            },
            // 汽车文件选择
            handleCarFileChange(file) {
                this.carImageUrl=null;
                this.carUseUrl=false;
                const isImage = /\.(jpg|jpeg|png|bmp|tiff)$/i.test(file.name);
                const isLt10M = file.size / 1024 / 1024 < 10;

                if (!isImage) {
                    this.$message.error('只能上传图片文件!');
                    return false;
                }
                if (!isLt10M) {
                    this.$message.error('图片大小不能超过10MB!');
                    return false;
                }
                console.log('handleCarFileChange file',file)
                this.carImageFile = file.raw;
                this.carImagePreview = URL.createObjectURL(file.raw);
                this.originalImage = this.carImagePreview;



                // 自动上传文件
                this.uploadCarFile(file.raw);
                this.openCar=false;
                return true;
            },

            // 轮毂文件选择
            handleWheelFileChange(file) {
                const isImage = /\.(jpg|jpeg|png|bmp|tiff)$/i.test(file.name);
                const isLt10M = file.size / 1024 / 1024 < 10;

                if (!isImage) {
                    this.$message.error('只能上传图片文件!');
                    return false;
                }
                if (!isLt10M) {
                    this.$message.error('图片大小不能超过10MB!');
                    return false;
                }
                console.log('file',file)
                this.wheelImageFile = file.raw;
                //this.wheelImagePreview = URL.createObjectURL(file);

                // 自动上传文件
                this.uploadWheelFile(file.raw);

                return true;
            },

            // 上传汽车文件
            async uploadCarFile(file) {
                try {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('type', 'car');

                    const response = await this.api.post('/api/upload', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    if (response && response.file_info) {
                        this.uploadedFiles.car = response.file_info;
                        this.$message.success('汽车图片上传成功!');
                    } else {
                        throw new Error('上传响应格式错误');
                    }
                } catch (error) {
                    console.error('汽车图片上传失败:', error);
                    this.$message.error('汽车图片上传失败: ' + (error.response?.data?.error || error.message));
                }
            },

            // 上传轮毂文件
            async uploadWheelFile(file) {
                try {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('type', 'wheel');

                    const response = await this.api.post('/api/upload', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    if (response && response.file_info) {
                        this.uploadedFiles.wheel = response.file_info;
                        this.$message.success('轮毂图片上传成功!');
                    } else {
                        throw new Error('上传响应格式错误');
                    }
                } catch (error) {
                    console.error('轮毂图片上传失败:', error);
                    this.$message.error('轮毂图片上传失败: ' + (error.response?.data?.error || error.message));
                }
            },

            // 从URL加载汽车图片
            loadCarImageFromUrl() {

                this.drawerCar=true;
                if (!this.carImageUrl) {
                    this.$message.warning('请输入汽车图片URL!');
                    return;
                }

                if (!this.carImageUrl.startsWith('http')) {
                    this.$message.error('请输入有效的URL!');
                    return;
                }

                this.carImagePreview = this.carImageUrl;
                this.originalImage = this.carImageUrl;
                this.$message.success('汽车图片URL加载成功!');


            },

            // 从URL加载轮毂图片
            loadWheelImageFromUrl() {
                this.drawerHub=true;
                // if (!this.wheelImageUrl) {
                //     this.$message.warning('请输入轮毂图片URL!');
                //     return;
                // }
                //
                // if (!this.wheelImageUrl.startsWith('http')) {
                //     this.$message.error('请输入有效的URL!');
                //     return;
                // }
                //
                // this.wheelImagePreview = this.wheelImageUrl;
                // this.$message.success('轮毂图片URL加载成功!');
            },

            // 输入类型切换
            handleCarInputTypeChange() {
                this.carImageFile = null;
                this.carImageUrl = '';
                this.carImagePreview = null;
                this.uploadedFiles.car = null;

            },
            handleWheelInputTypeChange() {
                this.wheelImageFile = null;
                this.wheelImageUrl = '';
                this.wheelImagePreview = null;
                this.uploadedFiles.wheel = null;

            },

            // 检测轮毂
            async detectWheels() {
                if (!this.hasCarImage) {
                    this.$message.warning('请先选择汽车图片!');
                    return;
                }

                this.processing = true;
                this.progress = 30;
                this.loadingText = '正在检测轮毂...';

                try {
                    const formData = new FormData();

                    // 添加汽车图片
                    if (this.carImageFile) {
                        formData.append('car_file', this.carImageFile);
                    }else if (this.uploadedFiles.car && this.uploadedFiles.car.file_path) {
                        formData.append('car_url', this.uploadedFiles.car.file_path);
                    }  else if (this.carImageUrl) {
                        formData.append('car_url', this.carImageUrl);
                    }

                    // 添加置信度
                    formData.append('conf', this.confidence.toString());

                    this.progress = 60;
                    const startTime = Date.now();

                    // 调用API
                    const response = await this.api.post('/api/detect', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    this.processingTime = Date.now() - startTime;
                    this.detectionResult = response;
                    this.progress = 90;

                    if (response.detection_image) {
                        this.resultImage = response.detection_image;
                    }

                    this.progress = 100;
                    this.$message.success('轮毂检测完成!');

                    setTimeout(() => {
                        this.processing = false;
                        this.progress = 0;
                    }, 1000);

                } catch (error) {
                    this.processing = false;
                    this.progress = 0;
                    console.error('检测轮毂失败:', error);
                    this.$message.error('检测轮毂失败: ' + (error.response?.data?.error || error.message || '未知错误'));
                }
            },

            // 替换轮毂
            async replaceWheels() {
                if (!this.hasCarImage) {
                    this.$message.warning('请先选择汽车图片!');
                    return;
                }

                this.processing = true;
                this.progress = 20;
                this.loadingText = '正在替换轮毂...';
                this.drawerHub=false;
                try {
                    const formData = new FormData();

                    // 添加汽车图片
                    if (this.carImageFile) {
                        formData.append('car_file', this.carImageFile);
                    } else if (this.uploadedFiles.car && this.uploadedFiles.car.file_path) {
                        formData.append('car_url', this.uploadedFiles.car.file_path);
                    }  else if (this.carImageUrl) {
                        formData.append('car_url', this.carImageUrl);
                    }

                    // 添加轮毂图片（如果有）
                    if (this.hasWheelImage) {
                        if (this.wheelImageFile) {
                            formData.append('wheel_file', this.wheelImageFile);
                        }else if (this.uploadedFiles.wheel && this.uploadedFiles.wheel.file_path) {
                            formData.append('wheel_url', this.uploadedFiles.wheel.file_path);
                        } else if (this.wheelImageUrl) {
                            formData.append('wheel_url', this.wheelImageUrl);
                        }
                    }

                    // 添加其他参数
                    formData.append('conf', this.confidence.toString());
                    formData.append('return_image', 'true');

                    this.progress = 40;
                    const startTime = Date.now();

                    // 调用API
                    const response = await this.api.post('/api/replace', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });

                    this.processingTime = Date.now() - startTime;
                    this.detectionResult = response;
                    this.progress = 80;

                    if (response.result_image) {
                        this.resultImage = response.result_image;
                        this.srcList.push(this.resultImage)

                    }

                    this.progress = 100;
                    this.$message.success('轮毂替换完成!');
                    this.isOriginalImage=false;

                    setTimeout(() => {
                        this.processing = false;
                        this.progress = 0;
                    }, 1000);

                } catch (error) {
                    this.processing = false;
                    this.progress = 0;
                    console.error('替换轮毂失败:', error);
                    this.$message.error('替换轮毂失败: ' + (error.response?.data?.error || error.message || '未知错误'));
                }
            },

            // 下载结果
            async downloadResult() {
                if (!this.hasCarImage || !this.resultImage) {
                    this.$message.warning('没有可下载的结果!');
                    return;
                }

                try {
                    this.processing = true;
                    this.progress = 50;
                    this.loadingText = '正在准备下载...';

                    const formData = new FormData();

                    // 添加汽车图片
                    if (this.uploadedFiles.car && this.uploadedFiles.car.file_path) {
                        formData.append('car_url', this.uploadedFiles.car.file_path);
                    } else if (this.carImageFile) {
                        formData.append('car_file', this.carImageFile);
                    } else if (this.carImageUrl) {
                        formData.append('car_url', this.carImageUrl);
                    }

                    // 添加轮毂图片（如果有）
                    if (this.hasWheelImage) {
                        if (this.uploadedFiles.wheel && this.uploadedFiles.wheel.file_path) {
                            formData.append('wheel_url', this.uploadedFiles.wheel.file_path);
                        } else if (this.wheelImageFile) {
                            formData.append('wheel_file', this.wheelImageFile);
                        } else if (this.wheelImageUrl) {
                            formData.append('wheel_url', this.wheelImageUrl);
                        }
                    }

                    // 添加置信度
                    formData.append('conf', this.confidence.toString());

                    // 调用API
                    const response = await this.api.post('/api/replace/download', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        responseType: 'blob'
                    });

                    // 创建下载链接
                    const url = window.URL.createObjectURL(new Blob([response]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'replaced_wheels.jpg');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    this.progress = 100;
                    this.$message.success('下载完成!');

                    setTimeout(() => {
                        this.processing = false;
                        this.progress = 0;
                    }, 1000);

                } catch (error) {
                    this.processing = false;
                    this.progress = 0;
                    this.$message.error('下载失败: ' + (error.response?.data?.error || error.message || '未知错误'));
                }
            },

            // 清除所有
            clearAll() {
                this.carImageFile = null;
                this.wheelImageFile = null;
                this.carImageUrl = '';
                this.wheelImageUrl = '';
                this.carImagePreview = null;
                this.wheelImagePreview = null;
                this.originalImage = null;
                this.resultImage = null;
                this.detectionResult = null;
                this.uploadedFiles = {
                    car: null,
                    wheel: null
                };
                this.$message.info('已清除所有选择');
            }
        }
    };
</script>

<style scoped>
    .big-screen-container {
        min-height: 100vh;
        background: url("../../assets/bg.jpg");
        background-color: #030409;
        color: #fff;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
    }
    .header {
        text-align: center;
        margin-bottom: 20px;
    }

    .header h1 {
        font-size: 36px;
        margin: 0;
    }

    .header .time {
        font-size: 24px;
        color: #67C23A;
    }

    .main-content {
        flex: 1;
        display: flex;
        justify-content: space-between;

        gap: 10px;
    }


    .wheel-replacer-container {
        min-height: 100vh;
        /*background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);*/
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    }

    .app-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        margin-bottom: 20px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    }

    .title {
        margin: 0;
        font-size: 28px;
        font-weight: 600;
        padding: 15px 0;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    }

    .app-main {
        max-width: 1200px;
        margin: 0 auto;
    }
   /deep/ ..el-card{background: linear-gradient(135deg, #ff000 0%, #ff000 6%) !important;}
    .upload-card, .control-card, .result-card, .info-card {
        margin-bottom: 20px;
        border-radius: 10px;

        border: none;
        transition: all 0.3s ease;
    }

    .upload-card:hover, .control-card:hover, .result-card:hover, .info-card:hover {
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        transform: translateY(-2px);
    }

    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 20px;
        border-bottom: 1px solid #eee;
        background-color: #fafafa;
        border-radius: 10px 10px 0 0;
    }

    .card-header span {
        font-weight: 600;
        color: #333;
    }

    .upload-demo {
        text-align: center;
        padding: 20px;
    }

    .url-input {
        margin-bottom: 15px;
    }

    .file-info {
        margin-top: 10px;
        text-align: center;
    }

    .image-preview {
        margin-top: 15px;
        text-align: center;
        padding: 10px;
    }

    .preview-image {
        max-width: 100%;
        max-height: 200px;
        border-radius: 8px;
        border: 2px solid #dcdfe6;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .slider-container {
        padding: 20px;
    }

    .slider-label {
        display: block;
        margin-bottom: 10px;
        font-weight: 500;
        color: #606266;
        font-size: 14px;
    }

    .button-group {
        display: flex;
        gap: 12px;
        justify-content: center;
        align-items: center;
        height: 100%;
        flex-wrap: wrap;
        padding: 20px;
    }

    .result-image {
        width: 100%;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .loading-dialog {
        text-align: center;
        padding: 20px;
    }

    .loading-text {
        margin-top: 15px;
        color: #606266;
        font-size: 16px;
    }

    .info-card {
        margin-top: 20px;
    }

    .el-upload__tip {
        margin-top: 10px;
        color: #909399;
        font-size: 13px;
    }

    .el-tag {
        margin: 5px;
    }

    .status-indicator {
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 8px;
    }

    .status-ready {
        background-color: #67C23A;
    }

    .status-waiting {
        background-color: #E6A23C;
    }

    .status-error {
        background-color: #F56C6C;
    }

    /* 响应式设计 */
    @media (max-width: 768px) {
        .app-main {
            padding: 10px;
        }

        .button-group {
            flex-direction: column;
        }

        .el-col {
            margin-bottom: 15px;
        }

        .title {
            font-size: 22px;
        }
    }

    .ft_box{position: fixed;bottom: 0;left:0;right: 0;}

    .ft_box .ft_item{background-color: rgba(0, 0, 0, 0.8);}
    .active{background-color: #d5d5d5;border-radius: 5px;}
</style>
